import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { LoginSupportInfo } from '../../../components/LoginSupportInfo/LoginSupportInfo';
import { DiscoverDestinationSelectorForm } from '../../../components/RegionSelectorForm/DiscoverDestinationSelectorForm';
import { ILoginViewProps } from '../../Login.types';
import { useLoginRegionSelectStepPresenter } from './LoginRegionSelectStep.presenter';

export const LoginRegionSelectStep: FC<ILoginViewProps> = observer((props) => {
  const { loginPresenter } = props;
  const presenter = useLoginRegionSelectStepPresenter(props);
  const { t } = useTranslation();

  return (
    <UnauthorizedLayoutTemplate
      onBack={presenter.onBackHandler || undefined}
      title={t('auth_region_select')}
      info={<LoginSupportInfo />}
      message={loginPresenter.errorMessage}
    >
      <DiscoverDestinationSelectorForm
        destinations={presenter.regionsDestinations}
        onSubmit={presenter.onSubmit}
      />
    </UnauthorizedLayoutTemplate>
  );
});
